module.exports = __webpack_public_path__ + "static/media/galeryAbout10.b5a62dca.jpg";